export const FAQ_DATA = [
  {
    question: "Is PCCheckr safe to use?",
    answer: "Yes. PCCheckr is designed with safety as the top priority. We use read-only diagnostic commands that do not modify your system settings or personal files. Our AI analysis provides guidance, not automated changes, so you remain in full control of your PC."
  },
  {
    question: "Do I need technical knowledge?",
    answer: "Not at all. PCCheckr is built for everyone. We translate complex system logs into plain English reports with clear, step-by-step instructions that anyone can follow."
  },
  {
    question: "Does PCCheckr access my personal files?",
    answer: "No. We never access your photos, documents, browsing history, or passwords. Our diagnostic tools only read system-level metadata like hardware health, driver versions, and resource usage."
  },
  {
    question: "Can this damage my PC?",
    answer: "No. Because PCCheckr only performs read-only analysis, it cannot cause damage. It is a diagnostic tool, not a 'cleaner' or 'optimizer' that makes unapproved changes to your registry or system files."
  },
  {
    question: "What diagnostic data is collected?",
    answer: "We collect basic hardware specs (CPU, RAM, Storage), OS version, system logs, and resource usage metrics. This data is used exclusively to generate your report and is auto-deleted after 7 days."
  },
  {
    question: "Is PCCheckr free?",
    answer: "We offer free basic system checks to identify immediate red flags. For a deep, AI-powered health report with specific fix instructions, we charge a small one-time fee of £7.99."
  },
  {
    question: "How accurate are the reports?",
    answer: "Our AI analysis is cross-referenced with thousands of known Windows issues and hardware benchmarks. While no tool can be 100% perfect, PCCheckr provides highly accurate insights comparable to professional IT diagnostics."
  }
];
